import r from"./isSymbol.js";var t=r;var i=function(r){if("string"==typeof r||t(r))return r;var i=r+"";return"0"==i&&1/r==-Infinity?"-0":i};export{i as default};
//# sourceMappingURL=_toKey.js.map
